// Import styles
import '../css/main.css';

// Import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';

/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
});

// Load Events — kör direkt om DOM är klart (skripten ligger i footer), annars vänta.
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', (): void => {
    routes.loadEvents();
  });
} else {
  routes.loadEvents();
}
